<template>
  <div class="page-panel">
    <div class="page-panel__header">
      <div class="page-panel-header__control">
        <el-button class="page-panel-header-control-button" size="mini" type="primary" @click="addMember">新增
        </el-button>
      </div>
      <div class="page-panel-header__title">成员管理</div>
    </div>
    <div class="page-panel__body">
      <el-tabs v-model="activeName">
        <el-tab-pane label="专家委员会成员" name="专家委员会成员">
          <expert ref="expert" v-if="activeName=='专家委员会成员'"></expert>
        </el-tab-pane>
        <!-- <el-tab-pane label="企业会员" name="企业会员">
          <member></member>
        </el-tab-pane> -->
        <el-tab-pane label="用户管理" name="用户管理">
          <user ref="user" v-if="activeName=='用户管理'"></user>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import expert from './expert';
import member from './member';
import user from './user';
export default {
  data() {
    return {
      activeName: '专家委员会成员'
    };
  },
  methods: {
    addMember() {
      switch (this.activeName) {
        case '专家委员会成员':
          this.$refs.expert.openDialog();
          break;
        case '企业会员':
          this.addMemberTitle = '新增企业会员';
          break;
        case '用户管理':
          this.$refs.user.openDialog();
          break;
        default:
          break;
      }
    }
  },
  components: {
    expert,
    member,
    user
  }
};
</script>
<style lang="stylus" scoped>
.avatar-uploader .el-upload {
  border 1px dashed #d9d9d9
  border-radius 6px
  cursor pointer
  position relative
  overflow hidden
}
.avatar-uploader .el-upload:hover {
  border-color #409EFF
}
.avatar-uploader-icon {
  font-size 28px
  color #8c939d
  width 178px
  height 178px
  line-height 178px
  text-align center
}
.avatar {
  width 178px
  height 178px
  display block
}
</style>



// WEBPACK FOOTER //
// src/pages/adminPage/userCenter/index.vue